import { cookies } from 'lib/cookies'
import env from 'lib/env'

export interface Apply {
  vacancy: {
    id: number
    title: string
    source: string
  }
  company: {
    slug: string
    name: string
  }
  recommendations?: {
    name: string
    email: string
  } | null
  metric?: string
}

export const applyVacancyInJobs = (params: string, goToProfiler = false) => {
  cookies.set('redirect_url', window.location.href)

  let pathname = goToProfiler ? '/pre-profiler?' : '/curriculo?'
  pathname = pathname.concat(params)
  location.href = env.host_profile.concat(pathname)
}
